
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Définition de Love-Brand : transformer votre marque en un coup de cœur",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez la définition love-brand : une marque aimée et admirée par les consommateurs. Explorez les secrets derrière le succès des love-brands et leur impact.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Définition de Love-Brand : transformer votre marque en un coup de cœur",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez la définition love-brand : une marque aimée et admirée par les consommateurs. Explorez les secrets derrière le succès des love-brands et leur impact.",
        },
      ],
    };
  },
};
